// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_PB_SET_DESTINATION_CITY,
} from './constants';

export function pbSetDestinationCity(data) {
  return {
    type: HOME_PB_SET_DESTINATION_CITY,
    data: data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_PB_SET_DESTINATION_CITY:
      return {
        ...state,
        pbDestinationCity:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/pbSetDestinationCity.js